module.exports = __webpack_public_path__ + "img/pc_logo_left_bottom.14ade085.png";